import { useSticksDataContext } from "../../../../../../aem-components/product-details/providers";
export const useSetAggregation = () => {
    const { currentProduct, setCurrentSKU, fallbackProductsSkus } = useSticksDataContext();
    const setAggregation = ({ orderFrequency, packagingPreference, shouldUseFallback, onSuccess, predefinedSku, }) => {
        if (predefinedSku) {
            onSuccess?.();
            setCurrentSKU(predefinedSku);
            return true;
        }
        const relatedProductSku = shouldUseFallback
            ? fallbackProductsSkus?.[orderFrequency][packagingPreference]
            : currentProduct.aggregations?.[orderFrequency][packagingPreference]?.sku;
        if (!relatedProductSku) {
            return false;
        }
        onSuccess?.();
        setCurrentSKU(relatedProductSku);
        return true;
    };
    return { setAggregation };
};
//# sourceMappingURL=useSetAggregation.js.map